import {GraphQLHandler, HttpHandler} from 'msw'
import {flatMap, pipe, prop, values} from 'remeda'
import {z} from 'zod'

const MswHandler = z.instanceof(HttpHandler).or(z.instanceof(GraphQLHandler))
const MockModule = z.object({
  handlers: z.array(MswHandler).optional().default([]),
})
const MockModules = z.array(MockModule)

export const getHandlers = () => {
  return pipe(
    import.meta.glob('./**/*.mocks.ts', {eager: true}),
    values,
    (x) => MockModules.parse(x),
    flatMap(prop('handlers')),
  )
}
